import { ref } from 'vue'

import type { RequestVO, ResponseData } from '@/utils/axios/base_vo.ts'
import { custom_app_item, custom_app_list, type CustomApp } from './t_user_custom_app_generate_api.ts'

export const responseListCustomApp = ref<ResponseData<CustomApp[]>>({})
export const responseItemCustomApp = ref<ResponseData<CustomApp>>({})

export const custom_app_get_cache_list = async (requestVO?: RequestVO<CustomApp>) => {
    let isQuery = true

    if (requestVO != null && requestVO.config != null && requestVO.config.isCache) {
        if (responseListCustomApp.value.code != null) {
            isQuery = false
        }
    }

    if (isQuery == true) {
        const res = await custom_app_list(requestVO?.data, undefined, requestVO?.field, requestVO?.page)
        responseListCustomApp.value = res
        return res
    } else {
        return responseListCustomApp.value
    }
}

export const custom_app_get_cache_item = async (requestVO?: RequestVO<CustomApp>) => {
    let isQuery = true

    if (requestVO != null && requestVO.config != null && requestVO.config.isCache) {
        if (responseItemCustomApp.value.code != null) {
            isQuery = false
        }
    }

    if (isQuery == true) {
        const res = await custom_app_item(requestVO?.data)
        responseItemCustomApp.value = res
        return res
    } else {
        return responseItemCustomApp.value
    }
}
